import angular from "angular";

angular
    .module('ui-sentinel.calibrations.calibrationControlCenter')
    .factory('CalibrationControlCenterReportsService', CalibrationControlCenterReportsService);

CalibrationControlCenterReportsService.$inject = ['$rootScope', 'SentinelUiSession', 'localStorageService', 'CalibrationService'];

function CalibrationControlCenterReportsService($rootScope, SentinelUiSession, localStorageService, CalibrationService) {
    const maxReportCapacity = 5000;
    let totalCount = 0;
    const localStorageKey = 'CalibrationControlCenterReportsService';

    const service = {
        lastClientGuid: null,
        reports: [],
        selected: null,
        load: load,
        init: init,
        get: get,
        fromDate: moment().subtract(44, 'day').startOf('day'),
        toDate: moment().add(1, 'day').endOf('day'),
        isFull: false,
        clear: clear
    };
    activate();
    return service;

    ///////////////////////////////////////////////////

    function activate() {
        //in case this is a page reload event, check the local storage for 'cached' dates and use those
        const cachedDateRange = localStorageService.get(localStorageKey);
        if (cachedDateRange) {
            service.fromDate = moment(cachedDateRange.fromDate);
            service.toDate = moment(cachedDateRange.toDate);
        }

        $rootScope.$on('CLIENT_FOCUS_CHANGED', function (event, args) {
            clear();
        });
    }

    function clear() {
        service.lastClientGuid = null;
        service.selected = null;
        service.reports = [];
        service.isFull = false;
        service.fromDate = moment().subtract(7, 'day').startOf('day');
        service.toDate = moment().add(1, 'day').endOf('day');
    }

    function severity(report) {

        const now = moment();
        const dueDate = moment(report.nextDueDate);

        if (dueDate.isAfter(now))
            return 'ok';

        const duration = moment.duration(now.diff(dueDate));
        const days = duration.asDays();
        if (days < 10) {
            return 'ok';
        } else if (days >= 10 && days < 30) {
            return 'info';
        } else
            return 'warning';
    }

    function init() {
        clear();
        const cachedDateRange = localStorageService.get(localStorageKey);
        if (cachedDateRange) {
            service.fromDate = moment(cachedDateRange.fromDate);
            service.toDate = moment(cachedDateRange.toDate);
        } else {
            //set the default dates based on the latest report
            service.toDate = moment(service.fromDate).add(1, 'day').endOf('day');
            service.fromDate = moment(service.toDate).subtract(44, 'day').startOf('day');
        }
        load(service.fromDate, service.toDate);
    }

    function load(fromDate, toDate, refresh) {
        if (!fromDate || !toDate) {
            clear();
            return;
        }

        const oneYearAgo = moment().subtract(1, 'year');
        const fromMoment = moment.isMoment(fromDate) ? fromDate : moment(fromDate);
        const toMoment = moment.isMoment(toDate) ? toDate : moment(toDate);
        const maxToMoment = moment(fromMoment).add(45, 'day');

        if (fromMoment.isBefore(oneYearAgo) || toMoment.isBefore(fromMoment) || toMoment.isAfter(maxToMoment)) {
            return;
        }

        if (!refresh && service.lastClientGuid === SentinelUiSession.focus.id &&
            fromMoment.isSame(service.fromDate) && toMoment.isSame(service.toDate)) {
            //do not reload the same data set again
            return;
        }

        $rootScope.loading = true;

        service.lastid = SentinelUiSession.focus.id;
        service.selected = null;
        service.fromDate = fromMoment;
        service.toDate = toMoment;
        totalCount = 0;

        const cachedDateRange = {
            fromDate: service.fromDate.toISOString(),
            toDate: service.toDate.toISOString()
        };
        localStorageService.set(localStorageKey, cachedDateRange);
        let guid = new Date().getTime();
        const fromDateIso = (fromDate instanceof moment) ? fromDate.toISOString() : moment(fromDate).toISOString();
        const toDateIso = (toDate instanceof moment) ? toDate.toISOString() : moment(toDate).toISOString();
        const promise = CalibrationService.GetPivotAssetCalibrationList(SentinelUiSession.focus.id, fromDateIso, toDateIso).$promise;
        promise.then(
            function (results) {
                const items = [];
                _.forEach(results, function (item) {
                    item.guid = guid++;
                    item.severity = severity(item);

                    if (item.latestSentinelStatus) {
                        for (let key in item.latestSentinelStatus) {
                            if (key != "latitude" && key != "longitude")
                                item[key] = item.latestSentinelStatus[key];
                        }
                    }

                    items.push(item);
                });
                console.log("items", items);
                totalCount = items.length;
                service.reports = items;
                service.isFull = service.reports.length >= maxReportCapacity;
            },
            function (error) {
                console.log(error);
            }
        ).finally(function () {
            $rootScope.loading = false;
        });
    }

    function get(guid) {
        let result = null;
        _.forEach(service.reports, function (report) {
            if (report.guid == guid) {
                result = report;
                return false;
            }
        });
        return result;
    }
}
